import { render } from "./EinstellungenTab.vue?vue&type=template&id=3cadaed8"
import script from "./EinstellungenTab.vue?vue&type=script&lang=js"
export * from "./EinstellungenTab.vue?vue&type=script&lang=js"

import "./EinstellungenTab.vue?vue&type=style&index=0&id=3cadaed8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__